export const CONTRACT_TEAMS_ERROR = 'CONTRACT_TEAMS_ERROR';
export const CONTRACT_TEAM_GET = 'GET_CONTRACT_TEAM_INIT';
export const CONTRACT_TEAM_GET_ALL = 'CONTRACT_TEAM_GET_ALL';
export const CONTRACT_TEAM_COUNT = 'GET_CONTRACT_TEAM_COUNT';
export const CONTRACT_TEAM_SAVE = 'GET_CONTRACT_TEAM_SAVE';
export const CONTRACT_TEAM_ADD_UPDATE = 'GET_CONTRACT_TEAM_ADD_UPDATE';
export const CONTRACT_TEAM_APPLY_MULTI_EDIT = 'CONTRACT_TEAM_APPLY_MULTI_EDIT';
export const CONTRACT_TEAM_CLEAR = 'CONTRACT_TEAM_CLEAR';
export const CONTRACT_TEAM_CLEAR_ALL_UPDATES = 'CONTRACT_FEES_CLEAR_ALL_UPDATES';
export const CONTRACT_TEAM_TEMPLATE_GET = 'CONTRACT_TEAM_TEMPLATE_GET';
export const CONTRACT_TEAM_AMENDMENTS = 'CONTRACT_TEAM_AMENDMENTS';
export const CONTRACT_TEAM_REMOVE_ALL_EDITS = 'CONTRACT_TEAM_REMOVE_ALL_EDITS';
export const CONTRACT_TEAM_GET_REFINE = 'CONTRACT_TEAM_GET_REFINE';
export const CONTRACT_TEAM_REFINE_CLEAR = 'CONTRACT_TEAM_REFINE_CLEAR';
export const CONTRACT_TEAM_GET_GROUP_UPDATER = 'CONTRACT_TEAM_GET_GROUP_UPDATER';
export const CONTRACT_TEAM_GROUP_UPDATER_FILTER = 'CONTRACT_TEAM_GROUP_UPDATER_FILTER';
export const CONTRACT_TEAM_GROUP_UPDATER_UPDATES = 'CONTRACT_TEAM_GROUP_UPDATER_UPDATES';
export const CONTRACT_TEAM_GROUP_UPDATER_CLEAR = 'CONTRACT_TEAM_GROUP_UPDATER_CLEAR';
export const CONTRACT_TEAM_REFINE_FILTERS_CLEAR = 'CONTRACT_TEAM_REFINE_FILTERS_CLEAR';
